import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RenderedService } from '../../rendered.service';
import { ViewUpdateService } from '@scaffold/services/view-update.service';
import { SearchModalComponent } from '@scaffold/editor/controls/search-modal/search-modal.component';
import { ActivatedRoute } from '@angular/router';
import { CourseService } from '@scaffold/services/course.service';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * @fileoverview this component displays linked items as a specified type in horizontal or vertical label
 */

@Component({
    selector: 'scaffold-data-link-label',
    templateUrl: './data-link-label.component.html',
    styleUrls: [
        '../../rendered.component.scss',
        './data-link-label.component.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DataLinkLabelComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  @Input() item;
  @Input() data;
  dialogRef: ScaffoldDialogRef;
  public destroy$: Subject<boolean> = new Subject<boolean>();
  link_data = [];
  isLast: any;

  /**
   *
   * @param cdr
   * @param renderedService
   * @param viewUpdate
   * @param dialog
   * @param route
   * @param courseService
   */

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private viewUpdate: ViewUpdateService,
    public dialog: ScaffoldDialogService,
    private route: ActivatedRoute,
    private courseService: CourseService
  ) {
    super(cdr, renderedService);
  }

  /**
   * @data any
   */

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe(trigger => {
        this.cdr.detectChanges();
      });

    if (this.item.linked) {
      this.item.linked.forEach(item => this.link_data.push({}));
    }
    /**
     * @success true
     */
    this.viewUpdate
      .registerListUpdate()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        if (data && this.item.toload_type === data.type) {
          if (data.hasOwnProperty('removed')) {
            console.log('removed');
            var index = -1;
            if (
              (data.list_type === 'link' && this.info.id == data.parent_id) ||
              data.list_type === 'list'
            ) {
              this.item.linked.forEach((item, i) => {
                if (item.id == data.removed) {
                  index = i;
                }
              });
              if (index >= 0) {
                this.item.linked.splice(index, 1);
              }
              index = -1;
              this.info.links.forEach((item, i) => {
                if (item.linked_id == data.removed) {
                  index = i;
                }
              });
              if (index >= 0) {
                this.info.links.splice(index, 1);
              }
            }
            this.update();
          }
          if (data.hasOwnProperty('added')) {
            console.log('added');
            if (data.list_type === 'link' && this.info.id == data.parent_id) {
              this.courseService
                .get(
                  data.added.type +
                    '/' +
                    data.added.id +
                    '?mode=' +
                    (this.item.toload_mode || 'list')
                )
                .subscribe(co => {
                  console.log(co);
                  if (co.push) {
                    co = co[0];
                  }

                  if (co.listItems) co = co.listItems[0];
                  co.link_id = data.added.link_id;
                  co.link_parent = this.info.id;
                  co.link_parent_type = this.info.type;
                  this.item.linked.push(co);
                  this.item.linked.sort((a, b) => {
                    let order = parseInt(a.position) - parseInt(b.position);
                    if (order === 0) {
                      if (a.id === b.parent_id) order = -1;
                      if (b.id === a.parent_id) order = 1;
                    }
                    return order;
                  });
                  this.info.links.push({
                    linked_id: co.id,
                    type: co.type,
                    title: co.title,
                  });
                  this.update();
                });
            }
          }
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  getContext() {
    console.log('CONTEXT: ' + this.item.parent_context);
    let context;
    if (this.item.parent_context == 'specified') {
      if (this.item.specified_type && this.item.value)
        context = { type: this.item.specified_type, id: this.item.value };
      else context = null;
    } else if (this.item.parent_context == 'all') {
      context = null;
    } else {
      context = { type: 'courses', id: this.courseService.id };
      if (this.item.get_all) {
        context.get_all = true;
      }
    }
    return context;
  }

  /**
   *
   * @param selectedItem
   * @param context
   * @param allow_multiple
   */

  openSearch(selectedItem, context, allow_multiple?): void {
    if (this.checkDisable()) return null;
    console.log(selectedItem);
    let settings: any = {
      context: {
        data: {
          paginate_results: true,
          selectedItem: selectedItem,
          currentValue: this.item.value,
          type: this.item.type,
          search_type: this.item.toload_type,
          search_mode: this.item.search_mode || 'list',
          context: context,
          route: this.route,
          allow_multiple: allow_multiple,
          window_title:
            this.item.search_title && this.item.search_title.length > 0
              ? this.item.search_title
              : 'Select Items to Link' +
                (selectedItem.title ? ' to ' + selectedItem.title : ''),
          horizontal_list: this.item.horizontal_list,
          hide_search: this.item.hide_search,
          filter: this.item.filter_search,
          params: { param: this.item.param, req_value: this.item.req_value },
          prevent_create: this.item.prevent_create,
          use_dynamic_headers: this.item.use_dynamic_headers,
          headers: this.item?.headers,
        },
      },
    };
    this.dialogRef = this.dialog.open(SearchModalComponent, settings);

    this.dialogRef.onClose.subscribe(result => {
      if (result && result.length > 0) {
        console.log('Create Link');
        this.renderedService.createLink(this.item, selectedItem, result, false);
      }
    });
  }

  linkCount() {
    let count = 0;
    if (this.info && this.info.links) {
      this.info.links.forEach(link => {
        if (link.type === this.item.toload_type) count++;
      });
    }
    return count;
  }
}
